import './PreviewCardProfilWithRole.scss';

import { Chip } from '@mui/material';
import classNames from 'classnames';
import { UserProfil } from 'domain/profil/UserProfil';
import { RoleStructure } from 'domain/roleStructure/RoleStructure';
import { Structure } from 'domain/structure/Structure';
import { StructureMember } from 'domain/structureMember/StructureMember';
import { UserProfilView } from 'domain/user/UserProfilView';
import { CardMercatoPlayerAnnouncementOverview } from 'primary/Components/CardMercatoAnnouncementOverview/CardMercatoPlayerAnnouncementOverview';
import { ModalEditRole } from 'primary/Components/StructureProfil/ModalEditRole';
import { useBooleanToggle } from 'primary/hooks/useBooleanToggle';
import { useTranslate } from 'primary/hooks/useTranslate';
import { StructureMembersDatatableMenu } from 'primary/Structure/StructureMembersDatatableMenu';
import React from 'react';

interface PreviewCardProfilWithRoleProps {
  profil: UserProfil | UserProfilView;
  userId?: number;
  structure?: Structure;
  onSubmitted?: () => void;
  role: RoleStructure;
  isTemp?: boolean;
  className?: string;
  readonly?: boolean;
  onClickEditMember?: () => void;
  member?: StructureMember;
}

export const PreviewCardProfilWithRole = ({
  profil,
  userId,
  structure,
  onSubmitted,
  role,
  isTemp,
  className,
  readonly,
  onClickEditMember,
  member,
}: PreviewCardProfilWithRoleProps) => {
  const t = useTranslate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [isOpen, toggleOpen, openModal, closeModal] = useBooleanToggle();

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classNames('previewCardProfilWithRole', className)}>
      {isTemp && readonly && (
        <div className={'previewCardProfilWithRole__temp'}>
          {t('structure.inviteResponseWaiting')}
        </div>
      )}
      <div className={'previewCardProfilWithRole__header'}>
        <span>{t(`structure.roles.${role.code}`)}</span>
        {isTemp && !readonly && (
          <Chip
            //@ts-ignore
            label={t(`structure.members.datatable.statusPending.${member?.state}`)}
            size={'small'}
          ></Chip>
        )}
        {!readonly && !!member && onSubmitted && (
          <div className={'-btnMenu'}>
            <StructureMembersDatatableMenu
              retry={onSubmitted}
              member={member}
              readonly={readonly}
              onClickEditMember={onClickEditMember}
              onClickDeleteMember={onClickEditMember}
            />
          </div>
        )}
      </div>
      <CardMercatoPlayerAnnouncementOverview
        className={'-cardMember'}
        key={profil.id}
        profil={profil}
      />
      {onSubmitted && member && (
        <ModalEditRole
          member={member}
          isOpen={isOpen}
          handleClose={closeModal}
          userId={userId}
          structure={structure}
          roleId={role.id}
          onSubmitted={onSubmitted}
          name={profil.idPlayer || ''}
        />
      )}
    </div>
  );
};
